var styles = {"box":"LinkCollectionV2_box_19nre_62","title":"LinkCollectionV2_title_19nre_115","expanded":"LinkCollectionV2_expanded_19nre_125","lines":"LinkCollectionV2_lines_19nre_128","list":"LinkCollectionV2_list_19nre_134","link":"LinkCollectionV2_link_19nre_140","show":"LinkCollectionV2_show_19nre_146"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
